import { Button } from 'reactstrap';
import { useHotkeys } from 'react-hotkeys-hook';

import { getShortcutDescription } from '../../utils/shortcuts';

const ButtonWithShortcut = ({ as = null, shortcut, ...innerProps }) => {
  const { disabled, onClick } = innerProps;

  const Component = as ?? Button;

  useHotkeys(shortcut, onClick, [onClick], { enabled: !disabled });

  const shortcutDescription = getShortcutDescription(shortcut);

  return (
    <Component
      {...innerProps}
      // Add tooltip to show shortcut:
      title={innerProps.title ?? shortcutDescription}
    />
  );
};

export default ButtonWithShortcut;
